import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Button } from '../../UI/Buttons';
import { Text } from '../../UI/Typography';
import { Input } from '../../UI/Inputs';
import { Modal, Overlay } from '../../UI/Containers';

const ModalHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.md};
  padding-bottom: ${({ theme }) => theme.spacing.sm};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-top: ${({ theme }) => theme.spacing.lg};
`;

const Row = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.md};
`;

const EditTimesModal = ({ isOpen, onClose, onSave, item }) => {
  const [inTime, setInTime] = useState('');
  const [outTime, setOutTime] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (isOpen && item) {
      setInTime(item.in_time || '');
      setOutTime(item.out_time || '');
      setIsSaving(false);
    } else if (!isOpen) {
      setInTime('');
      setOutTime('');
      setIsSaving(false);
    }
  }, [isOpen, item]);

  if (!isOpen || !item) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !isSaving) onClose();
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onSave({ username: item.username, date: item.date, in_time: inTime || null, out_time: outTime || null });
      // parent should refresh data and close modal
    } catch (err) {
      console.error('Failed to save edit times:', err);
      setIsSaving(false);
    }
  };

  return (
    <Overlay onClick={handleOverlayClick}>
      <Modal maxWidth="420px">
        <ModalHeader>
          <Text size="lg" weight="semibold" style={{ margin: 0 }}>Edit Attendance Times</Text>
          <Text size="sm" color="#6b7280" style={{ margin: 0 }}>{item.first_name || item.username} — {item.date}</Text>
        </ModalHeader>

        <Row>
          <div style={{ flex: 1 }}>
            <Text size="sm" weight="semibold" style={{ marginBottom: 6 }}>Check-in</Text>
            <Input type="time" value={inTime || ''} onChange={(e) => setInTime(e.target.value)} disabled={isSaving} />
          </div>
          <div style={{ flex: 1 }}>
            <Text size="sm" weight="semibold" style={{ marginBottom: 6 }}>Check-out</Text>
            <Input type="time" value={outTime || ''} onChange={(e) => setOutTime(e.target.value)} disabled={isSaving} />
          </div>
        </Row>

        <ButtonGroup>
          <Button variant="outline" onClick={onClose} disabled={isSaving}>Cancel</Button>
          <Button onClick={handleSave} loading={isSaving} disabled={isSaving}>{isSaving ? 'Saving...' : 'Save'}</Button>
        </ButtonGroup>
      </Modal>
    </Overlay>
  );
};

export default EditTimesModal;
